<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ConstData from './const/Const'

export default {
  name: 'App',
  data() {
    return {
      CheckAdmin: false,
      dialog: false,
      drawer: true,
      items: [
        {title: 'โปรไฟล์', page: '/', icon: 'mdi-account'},
        {title: 'โครงการ', page: '/Project2', icon: 'mdi-feature-search-outline'},
      ],
      mednet: '',
      color: 'primary',
      colors: [
        'primary',
        'blue',
        'success',
        'red',
        'teal',
      ],
      right: true,
      miniVariant: false,
      expandOnHover: false,
      background: true,
    }
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initPermissionData: 'Permission/initPermissionData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionData: 'Permission/getPermissionData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      initApproveProjectData: 'Project/initApproveProjectData',
    }),
    ToggleMenuClose: function () {
      window.console.log('ToggleMenu')
      // this.drawer = false;
    },
    LogOut() {
      document.cookie = 'access_token=; Max-Age=0'
      window.location.href = ConstData.ConnectionHost + '/SingleSign/';
      this.dialog = false
    }
  },
  computed: {
    bg() {
      return this.background ? 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg' : undefined
    },
    ...mapGetters({
      MeData: 'Staff/getMeData',
      AllPermission: 'Permission/getAllPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      PermissionAdmin: 'Permission/getPermission',
      ApproveProject: 'Project/getApproveProject',
    })
  },
  mounted() {
    this.initApproveProjectData()
    this.initMeData().then(res => {
      if (res) {
        this.mednet = ConstData.ConnectionMedNet + '/Personal/ShowPictNew.php?pid=' + this.MeData[0].perid
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(res => {
          if (res) {
            if (this.PermissionAdmin.length > 0) {
              this.PermissionAdmin.map(Per_i => {
                switch (Per_i.permission_id) {
                  case '7000' :
                    this.items.push(
                        {
                          title: 'เข้าร่วมโครงการ',
                          page: '/JoinProject',
                          icon: 'mdi-clipboard-account'
                        },
                    )
                    break
                  case '9000' :
                    this.items.push(
                        {
                          title: 'จัดการข้อมูลโครงการ',
                          page: '/ManageProject',
                          icon: 'mdi-view-grid-outline'
                        },
                    )
                    break
                  case '10000' :
                    this.items.push(
                        {
                          title: 'วางแผนตั้งงบโครงการ',
                          page: '/Propose_a_plan',
                          icon: 'mdi-view-grid-outline'
                        },
                    )
                    break
                  case '1000' :
                    this.items.push(
                        {
                          title: 'พิจารณาโครงการ',
                          page: '/Project',
                          icon: 'mdi-view-grid-outline'
                        },
                    )
                    break;
                  case '2000' :
                    this.items.push(
                        {
                          title: 'จัดการข้อมูลหลักสูตร',
                          page: '/ManageCourse',
                          icon: 'mdi-clipboard-multiple-outline'
                        },
                    )
                    break;
                  case '3000' :
                    this.items.push(
                        {
                          title: 'ตั้งค่าเงื่อนไขตำแหน่ง',
                          page: '/PositionPerCourse',
                          icon: 'mdi-clipboard-multiple-outline'
                        },
                    )
                    break
                  case '4000' :
                    this.items.push(
                        {
                          title: 'ตั้งค่า Competency',
                          page: '/SettingCompetency',
                          icon: 'mdi-clipboard-multiple-outline'
                        },
                    )
                    break
                  case '16000' :
                    this.items.push(
                        {
                          title: 'ตั้งค่ารายละเอียดค่าใช้จ่าย',
                          page: '/SettingExpenses',
                          icon: 'mdi-clipboard-multiple-outline'
                        },
                    )
                    break
                  case '5000' :
                    this.items.push(
                        {
                          title: 'จัดการข้อมูลตำแหน่งบริหาร/หัวหน้าหน่วยงาน',
                          page: '/SettingManagerial',
                          icon: 'mdi-clipboard-multiple-outline'
                        },
                    )
                    break
                  case '6000' :
                    this.items.push(
                        {
                          title: 'รายงาน',
                          page: '/Report',
                          icon: 'mdi-clipboard-multiple-outline'
                        },
                    )
                    break
                  case '8000' :
                    this.items.push(
                        {
                          title: 'จัดการข้อมูลบุคคล',
                          page: '/ManagePerson',
                          icon: 'mdi-clipboard-multiple-outline'
                        },
                    )
                    break
                  default:
                    break;
                }
              })
              this.items.push(
                  {
                    title: 'พิจารณาแผนตั้งงบโครงการ',
                    page: '/BudgetProject',
                    icon: 'mdi-clipboard-multiple-outline'
                  },
              )
              this.items.push(
                  {
                    title: 'งานนโยบายและแผน',
                    page: '/Item_Code',
                    icon: 'mdi-clipboard-multiple-outline'
                  },
              )
              this.items.push(
                  {title: 'สิทธิ์การใช้งาน', page: '/Permission', icon: 'mdi-clipboard-multiple-outline'},
              )
            } else {
              this.getPermissionUserData({
                perid: this.MeData[0].perid
              }).then(res => {
                if (res) {
                  if (this.Permission.length > 0) {
                    this.Permission.map(Per_i => {
                      switch (Per_i.permission_id) {
                        case '7000' :
                          this.items.push(
                              {
                                title: 'เข้าร่วมโครงการ',
                                page: '/JoinProject',
                                icon: 'mdi-clipboard-account'
                              },
                          )
                          break
                        case '9000' :
                          this.items.push(
                              {
                                title: 'จัดการข้อมูลโครงการ',
                                page: '/ManageProject',
                                icon: 'mdi-view-grid-outline'
                              },
                          )
                          break
                        case '10000' :
                          this.items.push(
                              {
                                title: 'วางแผนตั้งงบโครงการ',
                                page: '/Propose_a_plan',
                                icon: 'mdi-view-grid-outline'
                              },
                          )
                          break
                        case '1000' :
                          this.items.push(
                              {
                                title: 'พิจารณาโครงการ',
                                page: '/Project',
                                icon: 'mdi-view-grid-outline'
                              },
                          )
                          break;
                        case '2000' :
                          this.items.push(
                              {
                                title: 'จัดการข้อมูลหลักสูตร',
                                page: '/ManageCourse',
                                icon: 'mdi-clipboard-multiple-outline'
                              },
                          )
                          break;
                        case '3000' :
                          this.items.push(
                              {
                                title: 'ตั้งค่าเงื่อนไขตำแหน่ง',
                                page: '/PositionPerCourse',
                                icon: 'mdi-clipboard-multiple-outline'
                              },
                          )
                          break
                        case '4000' :
                          this.items.push(
                              {
                                title: 'ตั้งค่า Competency',
                                page: '/SettingCompetency',
                                icon: 'mdi-clipboard-multiple-outline'
                              },
                          )
                          break
                        case '16000' :
                          this.items.push(
                              {
                                title: 'ตั้งค่ารายละเอียดค่าใช้จ่าย',
                                page: '/SettingExpenses',
                                icon: 'mdi-clipboard-multiple-outline'
                              },
                          )
                          break
                        case '5000' :
                          this.items.push(
                              {
                                title: 'จัดการข้อมูลตำแหน่งบริหาร/หัวหน้าหน่วยงาน',
                                page: '/SettingManagerial',
                                icon: 'mdi-clipboard-multiple-outline'
                              },
                          )
                          break
                        case '6000' :
                          this.items.push(
                              {
                                title: 'รายงาน',
                                page: '/Report',
                                icon: 'mdi-clipboard-multiple-outline'
                              },
                          )
                          break
                        case '8000' :
                          this.items.push(
                              {
                                title: 'จัดการข้อมูลบุคคล',
                                page: '/ManagePerson',
                                icon: 'mdi-clipboard-multiple-outline'
                              },
                          )
                          break
                        default:
                          break;
                      }
                    })
                  }
                }
              })
            }
            if (this.ApproveProject.length > 0) {
              if (this.ApproveProject.filter(Approve_i => Approve_i.perid == this.MeData[0].perid && Approve_i.type == '0').length > 0) {
                this.items.push(
                    {
                      title: 'จัดการข้อมูลสิทธิการใช้งาน',
                      page: '/SettingPermission',
                      icon: 'mdi-clipboard-multiple-outline'
                    },
                )
              }
            }
          } else {
            if (this.ApproveProject.length > 0) {
              if (this.ApproveProject.filter(Approve_i => Approve_i.perid == this.MeData[0].perid && Approve_i.type == '0').length > 0) {
                this.items.push(
                    {
                      title: 'จัดการข้อมูลสิทธิการใช้งาน',
                      page: '/SettingPermission',
                      icon: 'mdi-clipboard-multiple-outline'
                    },
                )
              }
            }
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(res => {
              if (res) {
                if (this.Permission.length > 0) {
                  this.Permission.map(Per_i => {
                    switch (Per_i.permission_id) {
                      case '7000' :
                        this.items.push(
                            {
                              title: 'เข้าร่วมโครงการ',
                              page: '/JoinProject',
                              icon: 'mdi-clipboard-account'
                            },
                        )
                        break
                      case '9000' :
                        this.items.push(
                            {
                              title: 'จัดการข้อมูลโครงการ',
                              page: '/ManageProject',
                              icon: 'mdi-view-grid-outline'
                            },
                        )
                        break
                      case '10000' :
                        this.items.push(
                            {
                              title: 'วางแผนตั้งงบโครงการ',
                              page: '/Propose_a_plan',
                              icon: 'mdi-view-grid-outline'
                            },
                        )
                        break
                      case '1000' :
                        this.items.push(
                            {
                              title: 'พิจารณาโครงการ',
                              page: '/Project',
                              icon: 'mdi-view-grid-outline'
                            },
                        )
                        break;
                      case '2000' :
                        this.items.push(
                            {
                              title: 'จัดการข้อมูลหลักสูตร',
                              page: '/ManageCourse',
                              icon: 'mdi-clipboard-multiple-outline'
                            },
                        )
                        break;
                      case '3000' :
                        this.items.push(
                            {
                              title: 'ตั้งค่าเงื่อนไขตำแหน่ง',
                              page: '/PositionPerCourse',
                              icon: 'mdi-clipboard-multiple-outline'
                            },
                        )
                        break
                      case '4000' :
                        this.items.push(
                            {
                              title: 'ตั้งค่า Competency',
                              page: '/SettingCompetency',
                              icon: 'mdi-clipboard-multiple-outline'
                            },
                        )
                        break
                      case '16000' :
                        this.items.push(
                            {
                              title: 'ตั้งค่ารายละเอียดค่าใช้จ่าย',
                              page: '/SettingExpenses',
                              icon: 'mdi-clipboard-multiple-outline'
                            },
                        )
                        break
                      case '5000' :
                        this.items.push(
                            {
                              title: 'จัดการข้อมูลตำแหน่งบริหาร/หัวหน้าหน่วยงาน',
                              page: '/SettingManagerial',
                              icon: 'mdi-clipboard-multiple-outline'
                            },
                        )
                        break
                      case '6000' :
                        this.items.push(
                            {
                              title: 'รายงาน',
                              page: '/Report',
                              icon: 'mdi-clipboard-multiple-outline'
                            },
                        )
                        break
                      case '8000' :
                        this.items.push(
                            {
                              title: 'จัดการข้อมูลบุคคล',
                              page: '/ManagePerson',
                              icon: 'mdi-clipboard-multiple-outline'
                            },
                        )
                        break
                      default:
                        break;
                    }
                  })
                }
              }
            })
          }
        })
        // this.init()
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
};
</script>

<style>
/*@import url('https://fonts.googleapis.com/css?family=Prompt&display=swap');*/

* {
  font-family: 'Sarabun', sans-serif;
}

@media print {
  .no-print  {
    display: none;
  }
  .printm  {
    display: block;
  }
}

/*strong {*/
/*  font-family: "THSarabunNew";*/
/*  font-weight: bold;*/
/*  color: black;*/
/*}*/

/*p {*/
/*  font-family: "THSarabunNew";*/
/*  font-size: 22px;*/
/*  color: black;*/
/*}*/

/*ul {*/
/*  font-family: "THSarabunNew";*/
/*  font-size: 22px;*/
/*  color: black;*/
/*}*/

/*ol {*/
/*  font-family: "THSarabunNew";*/
/*  font-size: 22px;*/
/*  color: black;*/
/*}*/

/*i {*/
/*  font-family: "THSarabunNew";*/
/*  font-size: 22px;*/
/*  color: black;*/
/*}*/

/*s {*/
/*  font-family: "THSarabunNew";*/
/*  font-size: 22px;*/
/*  color: black;*/
/*}*/

</style>
